import axios from "axios";
import {getProxyAccessToken} from "../../plugins/cookie-plugins"
import rulesHandler from "../../rulesHandler";

const state = {
    items: [],
    sports: [],
    sportsBestPlayed: []
};

const getters = {

    getItems(state, getters) {
        return state.items
    },
    getSports(state, getters) {
        return state.sports
    },

    getSportsBestPlayed(state, getters) {
        return state.sportsBestPlayed;
    }
};

const actions = {

    actionSportLive(context, payload) {
        context.state.sports[payload.index].detail = payload.detail;
    },
    actionSportActive(context, payload) {
        context.state.sports[payload.index].active = payload.active;
    },
    filterSport(context, payload) {
        // Filtro gli items da mostrare
        context.dispatch('filterItems', {items: context.state.sports, lang: payload.language}).then((items) => {
            context.commit('setItems', items);
        })

    },
    /* TODO change operator */

    async fetchSports(context, payload) { /* */

        let request = {
            language: (payload != undefined && payload.language != undefined) ? payload.language : undefined,

        }

        let urlsport = `${context.rootGetters['settings/getUrlApi']}/api/get-sports-front-v3`;

        await axios.post(`${urlsport}`, request, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})

            .then(res => {
                context.commit('setItems', res.data.data);
            })
            .catch(err => {
                console.log(err);
            });

    },

    async fetchSportsV1(context, payload) {

        if (context.rootGetters['settings/getGameConsole'] === 'marketview') {
            await context.dispatch('odds/fetchSportV2', payload, {root: true});
        } else {
            await context.dispatch('odds/fetchSportV1', payload, {root: true})
        }

        let request = {
            language: (payload != undefined && payload.language != undefined) ? payload.language : undefined,

        }

        let urlsport = `${context.rootGetters['settings/getUrlApi']}/api/get-sports-front`;

        await axios.post(`${urlsport}`, request, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})

            .then(res => {
                context.dispatch('applyRules', res.data.data).then((items_with_rules) => {
                    context.commit('setSports', items_with_rules);
                    var listitems = _.filter(items_with_rules, {active: true})
                    context.dispatch('filterItems', {items: listitems, lang: payload.language}).then((items) => {
                        context.commit('setItems', items);
                    })
                })
            })
            .catch(err => {
                console.log(err);
            });

    },
    async fetchSportsV2(context, payload) {
        let request = {
            language: (payload != undefined && payload.language != undefined) ? payload.language : undefined,

        }
        let urlsport = `${context.rootGetters['settings/getUrlApi']}/api/get-sports-front-v3`;

        await axios.post(`${urlsport}`, request, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})

            .then(res => {
                context.dispatch('applyRules', res.data.data).then((items_with_rules) => {
                    context.commit('setSports', items_with_rules);
                    var listitems = _.filter(items_with_rules, {active: true})
                    context.dispatch('filterItems', {items: listitems, lang: payload.language}).then((items) => {
                        context.commit('setItems', items);
                    })
                })
            })
            .catch(err => {
                console.log(err);
            });

    },

    async filterItems(context, payload) {

        let items_filtered = [];

        await _.forEach(payload.items, function (item) {
            var response = _.find(item.detail, {"lang": payload.lang})
            var textDesc = (response !== undefined) ? response.text : '*' + item.detail[0].text
            items_filtered.push({
                'id': item.id,
                'name': textDesc,
                '_id': item._id,
                'detail': item.detail,
                'active': item.active,
                'order': item.order
            });
        })

        return _.sortBy(items_filtered, ['order', 'name'])

    },

    async filterItemsV2(context, payload) {

        let items_filtered = [];

        await _.forEach(payload.items, function (item) {

            items_filtered.push({
                'id': item.id,
                'name': item.name,
                '_id': item._id,
                // 'detail': item.name,
                'active': item.active,
                'order': item.order
            });
        })

        return _.sortBy(items_filtered, ['order', 'name'])
    },

    async applyRules(context, items) {

        let scope = 'sport';
        let onlyManager = true;

        if (context.rootGetters['settings/getPlatformId'] > 0) {
            onlyManager = false
            var skinDetail = context.rootGetters['rules/getRulesSkin']
        }

        const checkRules = _.filter(context.rootGetters['rules/getRulesManager'], {'scope': scope})
        if (checkRules.length > 0) {
            const rulesManager = _.groupBy(checkRules, 'type');
            await rulesHandler.applyRules(rulesManager, items)
        } else {
            // console.log('Sport: Nessuna regola per il Manager')
        }

        if (!onlyManager) {
            const checkRulesSkin = _.filter(skinDetail, {'scope': scope})
            if (checkRulesSkin.length > 0) {
                const rulesSkin = _.groupBy(checkRulesSkin, 'type');
                await rulesHandler.applyRules(rulesSkin, items)
            }
        }
        return items
    },
    async getSportFrom_IdSport(context, payload) {

        let sports = context.rootGetters['sport/getSports'];

        let sportFound = sports.filter(sport => {
            return sport._id == payload._id;
        })

        if (sportFound.length > 0) {
            return sportFound[0]
        } else {
            return null;
        }
    },
    async setSportsBestPlayedAct(context, payload) {
        context.commit('setSportsBestPlayed', payload);
    },

    async setReceiptPrinted(context, payload) {

        let requestPayload = {
            platformId: +(context.rootGetters['settings/getPlatformId'])
        }

        if (payload.betCode != null) {
            requestPayload.betCode = payload.betCode
        }
        if (payload.code != null) {
            requestPayload.code = payload.code
        }

        let url = `${context.rootGetters['settings/getProxyUrl']}/bets/receipt/print`;

        return await axios.post(`${url}`, requestPayload, {'headers': {'Authorization': `Bearer ${getProxyAccessToken()}`}})
            .then(async (res) => {
                // console.log('res')
                // console.log(res)
            }).catch((error) => {
                console.log(error);
            });
    },
    async fetchMarketGuideQuickbet(context, payload) {

        let url = `${context.rootGetters['settings/getUrlApi']}/v3/print-template/prints/markets-guide-quickbet`;

        return axios.post(`${url}`, {},{
            'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`},
            responseType: 'blob'
        })

            .then(async res => {
                const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                window.open(url, '_blank');
                return res.data

            })
            .catch(err => {
                console.log(err);
            });
    },
};

const mutations = {

    setItems(state, payload) {
        state.items = payload;
    },
    setSports(state, payload) {
        state.sports = payload;
    },

    setSportsBestPlayed(state, payload) {
        state.sportsBestPlayed = payload;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
